// The Station scope discriminator the client sends on scoped publisher-admin
// reads (ADR-0036's server-resolved scope).
//
// The client NEVER sends a station set: it sends which KIND of scope it wants
// and the server resolves `all` from the caller's own claims. Keep this the
// only shape that reaches the API, so a scope token can never be mistaken for
// a station identifier.
//
// Mirrors selfservice-api/src/shared/station-scope.dto.ts.

import type { AdminContext } from './useAdminContext';

export type StationScopeRequest =
  | { scope: 'all' }
  | { scope: 'station'; slug: string };

/** The scope a scope-flexible page should request for the shell's mode. */
export function scopeForContext(ctx: AdminContext): StationScopeRequest {
  return ctx.mode === 'aggregated'
    ? { scope: 'all' }
    : { scope: 'station', slug: ctx.slug };
}
